import { supabase } from '../../shared/supabase/supabaseClient';
import { groupProductComboRows, type ProductCombo } from '../domain/productCombos';
import { invalidateComboParentProductIdsCache } from './comboParentProductIdsCache';

type ComboRow = {
  combo_product_id: string;
  component_product_id: string;
  component_name?: string | null;
  qty: number;
  sort_order: number;
  production_destination?: string | null;
  combo_valid_from?: string | null;
  combo_valid_until?: string | null;
};

/** Combos de un set de productos (padre → componentes). Solo productos con filas. */
export async function fetchProductCombos(
  productIds: string[],
): Promise<Map<string, ProductCombo>> {
  if (productIds.length === 0) return new Map();
  const { data, error } = await supabase.rpc('list_product_combos', {
    p_product_ids: productIds,
  });
  if (error) throw new Error(error.message);
  const rows = (Array.isArray(data) ? data : []) as ComboRow[];
  return groupProductComboRows(rows);
}

/** Reemplazo completo de componentes; [] desarma el combo (y limpia vigencia). */
export async function upsertProductCombo(
  productId: string,
  components: Array<{ productId: string; qty: number; sortOrder?: number }>,
  validity?: { validFrom: string | null; validUntil: string | null },
): Promise<void> {
  const { error } = await supabase.rpc('upsert_product_combo', {
    p_product_id: productId,
    p_components: components.map((c, i) => ({
      productId: c.productId,
      qty: c.qty,
      sortOrder: c.sortOrder ?? i + 1,
    })),
    ...(validity
      ? {
          p_validity: {
            validFrom: validity.validFrom,
            validUntil: validity.validUntil,
          },
        }
      : {}),
  });
  if (error) throw new Error(error.message);
  invalidateComboParentProductIdsCache();
}
